import type { Edge } from '@metro/graph'
import { EdgeType, Graph } from '@metro/graph'

/**
 * A copy of a graph whose change edges (transfers and walks) weigh
 * `transferPenaltySec` more, for the "fewest changes" search pass
 * (`RouteOptions.transferPenaltySec`), plus the way back to the real edges so
 * a found path keeps its real times. iOS / Android twin:
 * `TransferPenalisedGraph`.
 */
export function transferPenalisedGraph(
  source: Graph,
  transferPenaltySec: number,
): { readonly graph: Graph; readonly realEdges: (path: Edge[]) => Edge[] } {
  const graph = new Graph()
  const realByKey = new Map<string, Edge>()
  const key = (e: Edge): string =>
    `${e.from.id}|${e.from.lineID}|${e.to.id}|${e.to.lineID}|${e.realID}`
  for (const edge of source.allEdges()) {
    if (edge.type === EdgeType.Ride) {
      graph.addEdge(edge)
      continue
    }
    realByKey.set(key(edge), edge)
    graph.addEdge({ ...edge, weight: edge.weight + transferPenaltySec })
  }
  return { graph, realEdges: (path) => path.map((e) => realByKey.get(key(e)) ?? e) }
}
